/**
 * Initializes listeners for standard equipment section toggling behavior.
 */
export function initToggles() {
    const toggleSections = () => {
        const showGear = document.getElementById('toggle_gear_section').checked;
        const showTrinket = document.getElementById('toggle_trinket_section').checked;
        const showPit = document.getElementById('toggle_pit_section').checked;
        const showNone = !showGear && !showTrinket && !showPit;

        const gearSlots = ['helmet', 'chest', 'pants', 'weapon', 'ring', 'boots'];
        const trinketSlots = ['trinket1', 'trinket2'];
        const pitSlots = ['saddle', 'chanfron', 'peytral'];

        document.querySelectorAll('.empty-equipment-msg').forEach(el => {
            el.style.display = showNone ? 'block' : 'none';
        });

        document.querySelectorAll('.gear-slot').forEach(el => {
            const slot = el.getAttribute('data-slot');
            let show = true;
            if (gearSlots.includes(slot)) show = showGear;
            if (trinketSlots.includes(slot)) show = showTrinket;
            if (pitSlots.includes(slot)) show = showPit;

            el.style.display = show ? '' : 'none';

            // Also disable inputs so they aren't submitted
            const inputs = el.querySelectorAll('select, input');
            inputs.forEach(input => input.disabled = !show);
        });

        document.querySelectorAll('.gear-header, .gear-bulk-header, .gear-selector, .gear-individual-group').forEach(el => {
            el.style.display = showGear ? '' : 'none';
        });
        document.querySelectorAll('.gear-selector, .gear-individual-group').forEach(el => {
            el.querySelectorAll('select, input').forEach(input => input.disabled = !showGear);
        });

        document.querySelectorAll('.trinket-header, .trinket-bulk-header, .trinket-selector, .trinket-individual-group').forEach(el => {
            el.style.display = showTrinket ? '' : 'none';
        });
        document.querySelectorAll('.trinket-selector, .trinket-individual-group').forEach(el => {
            el.querySelectorAll('select, input').forEach(input => input.disabled = !showTrinket);
        });

        document.querySelectorAll('.pit-gear-header, .pit-bulk-header, .pit-gear-selector, .pit-individual-group').forEach(el => {
            el.style.display = showPit ? '' : 'none';
        });
        document.querySelectorAll('.pit-gear-selector, .pit-individual-group').forEach(el => {
            el.querySelectorAll('select, input').forEach(input => input.disabled = !showPit);
        });

        document.querySelectorAll('.clear-set-btn').forEach(btn => {
            const section = btn.getAttribute('data-section');
            let parentHeader = btn.parentElement;
            if (parentHeader && parentHeader.classList.contains('gear-section-header')) {
                // Ignore the very first header that houses the Save buttons (it does not have a clear-set-btn)
                if (section === 'gear') {
                    btn.disabled = !showGear;
                    parentHeader.style.display = showGear ? 'flex' : 'none';
                } else if (section === 'trinkets') {
                    btn.disabled = !showTrinket;
                    parentHeader.style.display = showTrinket ? 'flex' : 'none';
                } else if (section === 'pit-gear') {
                    btn.disabled = !showPit;
                    parentHeader.style.display = showPit ? 'flex' : 'none';
                }
            }
        });

        // Determine which sections are visible to apply separators accurately
        document.querySelectorAll('.gear-set').forEach(gearSet => {
            // Filter out the "Build Save" header which we don't want separators for, and keep only equipment headers
            const activeHeaders = Array.from(gearSet.querySelectorAll('.gear-section-header')).filter(header => {
                return header.style.display !== 'none' && !header.querySelector('.save-column-btn');
            });
            activeHeaders.forEach((header, index) => {
                if (index === 0) {
                    header.classList.remove('section-separator');
                } else {
                    header.classList.add('section-separator');
                }
            });
        });
    };

    document.getElementById('toggle_gear_section').addEventListener('change', toggleSections);
    document.getElementById('toggle_trinket_section').addEventListener('change', toggleSections);
    document.getElementById('toggle_pit_section').addEventListener('change', toggleSections);

    // Call once on load
    toggleSections();

    // Exclusivity logic for "All Stats" and "March Size" Scenarios
    const standardScenarios = [
        'toggle_attack', 'toggle_defense', 'toggle_dragon', 
        'toggle_sop', 'toggle_creatures', 'toggle_balanced'
    ].map(id => document.getElementById(id)).filter(Boolean);

    const exclusiveScenarios = [
        'toggle_all_stats', 'toggle_march_size'
    ].map(id => document.getElementById(id)).filter(Boolean);

    exclusiveScenarios.forEach(excCb => {
        excCb.addEventListener('change', (e) => {
            if (e.target.checked) {
                // Uncheck all standard scenarios
                standardScenarios.forEach(cb => {
                    if (cb.checked) {
                        cb.checked = false;
                        cb.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                });
                // Uncheck other exclusive scenarios
                exclusiveScenarios.forEach(otherExc => {
                    if (otherExc !== e.target && otherExc.checked) {
                        otherExc.checked = false;
                        otherExc.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                });
            }
        });
    });

    standardScenarios.forEach(stdCb => {
        stdCb.addEventListener('change', (e) => {
            if (e.target.checked) {
                // Uncheck all exclusive scenarios
                exclusiveScenarios.forEach(cb => {
                    if (cb.checked) {
                        cb.checked = false;
                        cb.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                });
            }
        });
    });

    // Custom March Size input container toggling
    const marchSizeCb = document.getElementById('toggle_march_size');
    const marchSizeInputs = document.getElementById('march_size_inputs_container');
    if (marchSizeCb && marchSizeInputs) {
        const updateInputsVisibility = () => {
            if (marchSizeCb.checked) {
                marchSizeInputs.classList.remove('hidden');
                // Enable inputs
                marchSizeInputs.querySelectorAll('input, select').forEach(input => input.disabled = false);
            } else {
                marchSizeInputs.classList.add('hidden');
                // Disable inputs
                marchSizeInputs.querySelectorAll('input, select').forEach(input => input.disabled = true);
            }
        };
        marchSizeCb.addEventListener('change', updateInputsVisibility);
        // Call once on init
        updateInputsVisibility();
    }

    // Mutual exclusion logic for March Size custom target scenarios
    const marchScenarios = [
        'march_scenario_keep',
        'march_scenario_player_sop',
        'march_scenario_rein_sop',
        'march_scenario_creatures'
    ].map(id => document.getElementById(id)).filter(Boolean);

    marchScenarios.forEach(cb => {
        cb.addEventListener('change', (e) => {
            if (e.target.checked) {
                // Uncheck all other scenarios
                marchScenarios.forEach(otherCb => {
                    if (otherCb !== e.target) {
                        otherCb.checked = false;
                    }
                });
            } else {
                // If they tried to uncheck the currently checked one, keep it checked!
                const anyChecked = marchScenarios.some(otherCb => otherCb.checked);
                if (!anyChecked) {
                    e.target.checked = true;
                }
            }
            // Trigger recalculation
            document.getElementById('gearForm')?.dispatchEvent(new Event('change', { bubbles: true }));
        });
    });

    // Set up clean numeric input formatting and constraints
    const setupNumericInput = (inputId, maxLimit, isDecimal = false, allowZero = false) => {
        const input = document.getElementById(inputId);
        if (!input) return;

        input.addEventListener('input', () => {
            let val = input.value;
            if (isDecimal) {
                // Keep digits and at most one decimal point
                val = val.replace(/[^0-9.]/g, '');
                const dotIdx = val.indexOf('.');
                if (dotIdx !== -1) {
                    val = val.slice(0, dotIdx + 1) + val.slice(dotIdx + 1).replace(/\./g, '');
                }
            } else {
                // Keep digits only
                val = val.replace(/[^0-9]/g, '');
            }
            
            if (val !== '') {
                const parsed = parseFloat(val);
                if (!isNaN(parsed) && parsed > maxLimit) {
                    val = maxLimit.toString();
                }
            }
            input.value = val;
            
            // Trigger recalculation on input
            document.getElementById('gearForm')?.dispatchEvent(new Event('change', { bubbles: true }));
        });

        input.addEventListener('blur', () => {
            let val = input.value;
            if (val.trim() === '') return;
            let parsed = parseFloat(val);
            const isInvalid = allowZero ? (isNaN(parsed) || parsed < 0) : (isNaN(parsed) || parsed <= 0);
            if (isInvalid) {
                input.value = '';
            } else {
                if (parsed > maxLimit) parsed = maxLimit;
                if (parsed % 1 === 0) parsed = Math.floor(parsed);
                input.value = parsed.toString();
            }
            document.getElementById('gearForm')?.dispatchEvent(new Event('change', { bubbles: true }));
        });
    };

    const setupEvaluator = (inputId, previewId, maxLimit) => {
        const input = document.getElementById(inputId);
        const preview = document.getElementById(previewId);
        if (!input) return;

        input.addEventListener('input', () => {
            let val = input.value;
            // Convert spaces to '+' dynamically
            val = val.replace(/ /g, '+');
            // Clean up consecutive plus signs
            val = val.replace(/\++/g, '+');
            // Allow only digits and '+'
            val = val.replace(/[^0-9+]/g, '');
            input.value = val;

            if (val.includes('+')) {
                const sum = evaluateEquation(val);
                if (isNaN(sum)) {
                    if (preview) preview.textContent = 'Invalid expression';
                } else {
                    if (preview) preview.textContent = `= ${formatNumber(sum)}`;
                }
            } else {
                if (preview) preview.textContent = '';
            }
            document.getElementById('gearForm')?.dispatchEvent(new Event('change', { bubbles: true }));
        });

        input.addEventListener('blur', () => {
            let val = input.value;
            if (val.trim() === '') {
                if (preview) preview.textContent = '';
                return;
            }
            const sum = evaluateEquation(val);
            if (isNaN(sum) || sum <= 0) {
                input.value = '';
                if (preview) preview.textContent = '';
            } else {
                if (val.includes('+')) {
                    if (preview) preview.textContent = `= ${formatNumber(Math.min(sum, maxLimit))}`;
                } else {
                    if (preview) preview.textContent = '';
                }
            }
            document.getElementById('gearForm')?.dispatchEvent(new Event('change', { bubbles: true }));
        });
    };

    setupEvaluator('unequipped_march_size', 'march_size_preview', 1000000);

    // Listen to changes on percent toggles to trigger recalculation
    document.getElementById('percent_toggle_waif')?.addEventListener('change', () => {
        document.getElementById('gearForm')?.dispatchEvent(new Event('change', { bubbles: true }));
    });
    document.getElementById('percent_toggle_keep_enh')?.addEventListener('change', () => {
        document.getElementById('gearForm')?.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Setup for compact/linked inputs
    const compactInput = document.getElementById('compact_march_size');
    const primaryInput = document.getElementById('unequipped_march_size');
    if (compactInput && primaryInput) {
        // Link compact to primary
        compactInput.addEventListener('input', () => {
            primaryInput.value = compactInput.value;
            primaryInput.dispatchEvent(new Event('input', { bubbles: true }));
        });

        compactInput.addEventListener('blur', () => {
            primaryInput.value = compactInput.value;
            primaryInput.dispatchEvent(new Event('blur', { bubbles: true }));
        });
        
        // Link primary back to compact
        primaryInput.addEventListener('input', () => {
            compactInput.value = primaryInput.value;
            const primaryPreview = document.getElementById('march_size_preview');
            const compactPreview = document.getElementById('compact_march_preview');
            if (primaryPreview && compactPreview) {
                compactPreview.textContent = primaryPreview.textContent;
            }
        });
        
        primaryInput.addEventListener('blur', () => {
            compactInput.value = primaryInput.value;
            const primaryPreview = document.getElementById('march_size_preview');
            const compactPreview = document.getElementById('compact_march_preview');
            if (primaryPreview && compactPreview) {
                compactPreview.textContent = primaryPreview.textContent;
            }
        });
    }
}

// Helper to evaluate text equation string
export function evaluateEquation(str) {
    if (!str) return 0;
    let s = str.trim();
    if (s.endsWith('+')) {
        s = s.slice(0, -1);
    }
    if (!s) return 0;
    if (!/^[0-9]+(\+[0-9]+)*$/.test(s)) {
        return NaN;
    }
    return s.split('+').reduce((sum, val) => sum + parseInt(val, 10), 0);
}

function formatNumber(num) {
    if (isNaN(num)) return '';
    return num.toLocaleString('en-US');
}

